/* Catalogue mocks. Thin re-exporters that adapt NETHRA_DATA.products into
 * the FastAPI response shapes (ProductListItem / ProductDetail). */

import { NETHRA_DATA } from "@/data/data";

const PRODUCTS = NETHRA_DATA.products || [];

/** Maps a raw NETHRA_DATA product onto ProductListItem. */
export function toListItem(p) {
  return {
    id: p.id,
    slug: p.slug,
    name: p.name,
    brand: p.brand,
    category_slug: p.category_slug,
    category_name: p.category_name,
    sub_category: p.sub_category ?? p.sub ?? null,
    stock_status: p.stock_status || p.stock || "in_stock",
    rating: p.rating ?? 0,
    reviews: p.reviews ?? 0,
    price_min: p.price_min ?? p.min ?? 0,
    price_max: p.price_max ?? p.max ?? (p.price_min ?? p.min ?? 0),
    is_featured: !!p.is_featured || !!p.featured,
    badge: p.badge ?? null,
    delivery_time_mins: p.delivery_time_mins ?? p.delivery ?? null,
    unit_label: p.unit_label ?? p.unit ?? "",
    schedule: p.schedule || "NONE",
  };
}

/** Builds 1–2 mock variants per product, each with role-tiered prices. */
function buildVariants(p) {
  const baseMin = p.price_min ?? p.min ?? 0;
  const baseMax = p.price_max ?? p.max ?? baseMin;
  const tiers = (mrp) => [
    { role: "customer",  mrp, selling_price: Math.round(mrp * 0.96), currency: "INR" },
    { role: "clinician", mrp, selling_price: Math.round(mrp * 0.90), currency: "INR" },
    { role: "retailer",  mrp, selling_price: Math.round(mrp * 0.82), currency: "INR" },
  ];
  if (baseMin === baseMax) {
    return [{
      id: `${p.id}-v1`,
      pack_size: p.unit_label || p.unit || "1 unit",
      unit_label: p.unit_label || p.unit || "1 unit",
      barcode: null,
      is_default: true,
      prices: tiers(baseMin),
    }];
  }
  return [
    {
      id: `${p.id}-v1`,
      pack_size: p.unit_label || p.unit || "1 unit",
      unit_label: p.unit_label || p.unit || "1 unit",
      barcode: null,
      is_default: true,
      prices: tiers(baseMin),
    },
    {
      id: `${p.id}-v2`,
      pack_size: "Bulk pack",
      unit_label: "Bulk pack",
      barcode: null,
      is_default: false,
      prices: tiers(baseMax),
    },
  ];
}

/** Maps onto ProductDetail. */
export function toDetail(p) {
  return {
    ...toListItem(p),
    description:
      p.description ||
      `${p.name} from ${p.brand}. Sold in ${p.unit_label || p.unit || "standard"} packs. Sourced from CDSCO-licensed warehouses with full batch traceability.`,
    hsn_code: p.hsn_code || "3004",
    specs: Array.isArray(p.specs) ? p.specs : [],
    variants: buildVariants(p),
    images: [
      { storage_key: "/elementor-placeholder-image.png", alt: p.name, is_primary: true, sort_order: 0 },
    ],
  };
}

export { PRODUCTS };
